module.exports = __webpack_public_path__ + "static/img/12.de1dbc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/12.jpg
// module id = d8gJ
// module chunks = 1